import React, { useEffect, useState } from "react";
import useValidator from "../../utils/useValidator";
import flexStyles from "../../style/flex";
import { Box, TextField } from "@material-ui/core";
import * as Yup from "yup";
import { useStyles } from "./style";
import PrimaryButton from "../../Components/UI/Buttons/PrimaryButton";
import LightButton from "../../Components/UI/Buttons/LightButton";
import { useDispatch, useSelector } from "react-redux";
import { reqDemo } from "../../Stores/Bundles/actions";
import moment from "moment";
import SkeletonLoader from "../../Components/UI/SkeletonLoader";

const EmailComponent = ({ slot, date, setStep, onDateChange, setSlot }) => {
  const flexClasses = flexStyles();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { isRequestingDemo } = useSelector((state) => state.BundlesReducer);
  let loading = isRequestingDemo;

  const triggerEmail = async (data) => {
    dispatch(
      reqDemo(data, () => {
        clearFormState();
        setStep(1);
        setSlot(`1:00 PM - 2:00 PM`);
        onDateChange(new Date(Date.now() + 86400000));
      })
    );
  };

  function onSubmit() {
    triggerEmail({ ...values, slot, date: moment(date).format("YYYY-MM-DD") });
  }

  const {
    errors,
    touched,
    values,
    handleSubmit,
    setValues,
    clearFormState,
    getFieldProps,
  } = useValidator({
    initialValues: {
      name: "",
      email: "",
      company_name: "",
      mobile: "",
    },
    onSubmit,
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required."),
      company_name: Yup.string().required("Company Name is required."),
      mobile: Yup.string()
        .test(
          `Contact Number format`,
          `Invalid Contact Number format!`,
          function (value) {
            const mobileRegex =
              /^((\+44(\s\(0\)\s|\s0\s|\s)?)|0)?\d{4}(\s)?\d{6}$/;
            return (
              typeof value === "string" &&
              mobileRegex.test(value.replace(/\s/g, ""))
            );
          }
        )
        .required("Contact Number is Required"),
      email: Yup.string()
        .email("Invalid Email!")
        .required("Email is required!"),
    }),
  });

  useEffect(() => {
    clearFormState();
  }, []);

  return (
    <div className={classes.emailWrap}>
      <Box className={classes.backContainer}>
        <LightButton onClick={() => setStep(1)}>Back</LightButton>
      </Box>
      <form onSubmit={handleSubmit}>
        <Box className={flexClasses.flexContainer}>
          <Box className={flexClasses.item}>
            {loading ? (
              <SkeletonLoader type="text" height={40} />
            ) : (
              <TextField
                variant="outlined"
                size="small"
                label="Name"
                placeholder="Name"
                value={values.name}
                helperText={touched.name && errors.name}
                error={!!(touched.name && errors.name)}
                onChange={(e) =>
                  setValues({
                    ...values,
                    name: e.target.value,
                  })
                }
                className={flexClasses.input}
              />
            )}
          </Box>
          <Box className={flexClasses.item}>
            {loading ? (
              <SkeletonLoader type="text" height={40} />
            ) : (
              <TextField
                variant="outlined"
                size="small"
                label="Email"
                value={values.email}
                helperText={touched.email && errors.email}
                error={!!(touched.email && errors.email)}
                {...getFieldProps("email")}
                className={flexClasses.input}
              />
            )}
          </Box>
          <Box className={flexClasses.item}>
            {loading ? (
              <SkeletonLoader type="text" height={40} />
            ) : (
              <TextField
                variant="outlined"
                size="small"
                label="Contact Number"
                value={values.mobile}
                helperText={touched.mobile && errors.mobile}
                error={!!(touched.mobile && errors.mobile)}
                {...getFieldProps("mobile")}
                className={flexClasses.input}
              />
            )}
          </Box>
          <Box className={flexClasses.item}>
            {loading ? (
              <SkeletonLoader type="text" height={40} />
            ) : (
              <TextField
                variant="outlined"
                size="small"
                label="Company Name"
                placeholder="Company Name"
                value={values.company_name}
                helperText={touched.company_name && errors.company_name}
                error={!!(touched.company_name && errors.company_name)}
                onChange={(e) =>
                  setValues({
                    ...values,
                    company_name: e.target.value,
                  })
                }
                className={flexClasses.input}
              />
            )}
          </Box>
        </Box>
        <Box className={classes.emailWrapActions}>
          <PrimaryButton
            type="submit"
            hideIcon={true}
            disabled={isRequestingDemo}
          >
            Submit
          </PrimaryButton>
        </Box>
      </form>
    </div>
  );
};

export default EmailComponent;
